import React, { useEffect, useRef, useState } from "react";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "./searchProducts.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { checkReplaceUrl, checkDocReplaceUrl, checkLearnMoreReplaceUrl } from "../utils";

export const SearchProducts = (productList) => {
  const { t } = useTranslation();
  const baseImageURL = "https://www.westerndigital.com/";
  // const [isListLoading, setIsListLoading] = useState(true);
  const isListLoading = useSelector(
    (state) => state?.searchLanding?.productCarousel?.isLoading
  );
  const productCarouselProductsDocs = useSelector(
    (state) => state?.searchLanding?.productCarousel?.products?.docs
  );
  let isRightNavAllowed = true;
  const isMobile = window.innerWidth < 1024;

  const splideRef = useRef(null);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const [isStart, setIsStart] = useState(true);
  let host = window.location.host;

  useEffect(() => {
    const checkLoading = productList?.productList ? true : false;
    if (productList?.productList?.length > 0) {
      setIsStart(true);
      setIsAtEnd(false);
      if (splideRef.current) {
        const splideInstance = splideRef.current.splide;

        if (splideInstance) {
          splideInstance.refresh(); // Refresh the slider
          splideInstance.go(0); // Move to the first slide
        }
      }
    }
    // setIsListLoading(checkLoading)
  }, [productList.productList]);
  const goToNextSlide = () => {
    if (splideRef.current) {
      if (splideRef.current) {
        const splideInstance = splideRef.current.splide;
        const currentIndex = splideInstance.index; // Current slide index
        const totalSlides = splideInstance.length; // Total number of slides
        console.log(currentIndex, totalSlides);
        // Check if we are at the last slide
        setIsAtEnd(currentIndex === 0);
        setIsStart(currentIndex === 1);
      }
      splideRef.current.splide.go(">"); // Moves to the next slide
    }
  };

  const goToPrevSlide = () => {
    if (splideRef.current) {
      if (splideRef.current) {
        const splideInstance = splideRef.current.splide;
        const currentIndex = splideInstance.index; // Current slide index
        const totalSlides = splideInstance.length; // Total number of slides
        // Check if we are at the last slide
        setIsAtEnd(currentIndex === 0);
        setIsStart(currentIndex === 1);
      }
      splideRef.current.splide.go("<"); // Moves to the previous slide
    }
  };

  useEffect(() => {
    const splide = splideRef.current?.splide;
    if (isMobile) {
      if (splide) {
        splide.on("move", () => {
          const isLastSlide =
            splide.index === splide.Components.Controller.getEnd();
          console.log(isLastSlide, "isLastSlide");
          const track = splide.Components.Elements.track;
          // Adjust padding dynamically
          if (isLastSlide) {
            console.log(track, "track");
            // Change inline padding to 0 for the last slide
            track.style.paddingRight = "6%";
          } else {
            // Restore original padding
            track.style.paddingRight = "20px";
          }
        });
      }
    } else {
      if (splide) {
        splide.on("move", () => {
          const splideInstance = splideRef.current.splide;
          const currentIndex = splideInstance.index; // Current slide index
          const totalSlides = splideInstance.length; // Total number of slides
          console.log(currentIndex, totalSlides);
          if (currentIndex > 0) {
            setIsAtEnd(true);
            setIsStart(false);
          } else {
            setIsAtEnd(false);
            setIsStart(true);
          }
        });
      }
    }

    // Cleanup event listener on component unmount
    return () => {
      if (splide) {
        // splide.destroy();
      }
    };
  }, []);

  return (
    <React.Fragment>
      <div className="sd-col-span-12 sd-grid lg:sd-grid-cols-12 sd-grid-cols-8 sd-gap-4 lg:sd-my-[58px] sd-mb-10 lg:sd-mr-0 sd--mr-4 sd-my-[2.7rem]">
        <div className="sd-col-span-12 sd-relative">
          {isListLoading ? (
            <div
              className="sd-skeleton sd-skeleton-text sd-mb-[14px] lg:sd-mb-[10px] "
              style={{ width: "80px" }}
            ></div>
          ) : (
            productList?.productList?.length > 0 && (
              <h2 className="sd-uppercase sd-text-[13px] sd-titleText sd-mb-[14px] lg:sd-mb-[8px]">
                {t("products")}
              </h2>
            )
          )}
          <div className={productCarouselProductsDocs?.length ? "" : "hidden"}>
            {!isStart && (
              <button
                class="sd-absolute sd-z-[9] sd-left-[26px] sd-top-1/2 sd-transform sd-translate-y-[-50%] sd-translate-x-[-50%] sd-bg-white sd-w-8 sd-h-8 sd-items-center sd-justify-center sd-rounded-full sd-rotate-180 sd-hidden lg:sd-flex"
                onClick={goToPrevSlide}
              >
                <svg
                  width="10"
                  height="9"
                  viewBox="0 0 10 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.96756 8.98596L9.40337 4.49298L5.96756 0L5.33207 0.48596L8.08978 4.09219H4.88162e-05V4.89219H8.09099L5.33207 8.5L5.96756 8.98596Z"
                    fill="black"
                  />
                </svg>
              </button>
            )}
            {!isAtEnd && (
              <button
                class="sd-absolute sd-z-[9] sd-right-[10px] sd-top-1/2 sd-transform sd-translate-y-[-50%] sd-bg-white sd-w-8 sd-h-8 sd-hidden lg:sd-flex sd-items-center sd-justify-center sd-rounded-full"
                onClick={goToNextSlide}
              >
                <svg
                  width="10"
                  height="9"
                  viewBox="0 0 10 9"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.96756 8.98596L9.40337 4.49298L5.96756 0L5.33207 0.48596L8.08978 4.09219H4.88162e-05V4.89219H8.09099L5.33207 8.5L5.96756 8.98596Z"
                    fill="black"
                  />
                </svg>
              </button>
            )}
          </div>

          <Splide
            ref={splideRef}
            options={{
              perPage: 4,
              perMove: 1,
              pagination: false,
              arrows: false,
              gap: "4px",
              height: "auto",
              wheel: false,
              padding: {
                left: "0%",
                right: "0%",
              },
              breakpoints: {
                1024: {
                  arrows: false,
                  wheel: false,
                  perPage: 1,
                  gap: 14,
                  // fixedWidth: '316px',
                  padding: {
                    left: "0%",
                    right: "20%",
                  },
                },
              },
            }}
          >
            {isListLoading
              ? // Skeleton Loader Component
                Array.from({ length: 5 }).map((_, index) => (
                  <SplideSlide key={index} aria-controls="...">
                    <div className="sd-text-left sd-flex sd-flex-col sd-mr-2 sd-h-auto sd-flex-1">
                      {/* Skeleton for Image */}
                      <div className="sd-bg-gray-200 sd-rounded-xs sd-flex sd-items-center sd-justify-center sd-my-2 sd-h-full">
                        <div className="sd-animate-pulse sd-mx-auto sd-mb-2 sd-bg-gray-300 sd-aspect-card sd-w-full" />
                      </div>

                      {/* Skeleton for Title */}
                      <div className="sd-bg-gray-300 sd-rounded-xs sd-ml-0 sd-mb-4 sd-h-[16px] sd-w-[50%] sd-animate-pulse" />

                      {/* Skeleton for Links */}
                      <div className="sd-my-1 sd-flex sd-flex-row">
                        <div className="sd-skeleton sd-skeleton-text sd-mb-0 sd-pr-3 sd-bg-gray-300"></div>
                        <div className="sd-skeleton sd-skeleton-text sd-mb-0 sd-pr-3 sd-bg-gray-300"></div>
                        <div className="sd-skeleton sd-skeleton-text sd-mb-0"></div>
                      </div>
                    </div>
                  </SplideSlide>
                ))
              : // Normal Content Component
                productList?.productList?.map((product) => (
                  <SplideSlide key={product.id} aria-controls="...">
                    <div className="sd-text-left sd-flex sd-flex-col sd-mr-[0.75rem] sd-h-auto sd-flex-1">
                      {/* Product Image */}
                      <div className="sd-bg-gray-200 sd-rounded-xs sd-flex sd-items-center sd-justify-center sd-my-2 sd-overflow-hidden sd-aspect-card">
                        <img
                          // src={`${product?.primaryImage?.includes("https://") ? product.primaryImage : baseImageURL + product.primaryImage}`}
                          src={checkReplaceUrl(product?.primaryImage)}
                          alt={product?.subject}
                          className="sd-mx-auto sd-object-contain sd-max-h-full sd-max-w-full"
                        />
                      </div>
                      {/* Product Title */}
                      <h3 className="sd-text-[13px] sd-mb-[1px]">
                        {product?.subject}
                      </h3>
                      {/* Links */}
                      <div className="sd-my-1 sd-flex sd-flex-row sd-flex-wrap sd-gap-x-1">
                        {product?.supportPageUrl_s ? 
                        <>
                          <a
                            href={checkReplaceUrl(product?.supportPageUrl_s)}
                            className="sd-text-sm hover:sd-no-underline sd-underline sd-cursor-pointer sd-py-1 sd-whitespace-nowrap sd-mb-0 sd-relative"
                          >
                            <span>{t("support")}</span>
                          </a>
                          <span className="sd-p-1">|</span>
                        </> :
                        <></>
                        }
                        {product?.dataSheet_s ? 
                        <>
                          <a
                            href={checkDocReplaceUrl(product?.dataSheet_s)}
                            className="sd-text-sm hover:sd-no-underline sd-underline sd-py-1 sd-whitespace-nowrap sd-mb-0 sd-relative"
                          >
                            {product?.dataSheet_s && (
                              <span>{t("dataSheet")}</span>
                            )}
                          </a>
                          <span className="sd-p-1">|</span>
                        </> :
                        <></>
                        }
                        {product?.url ? 
                        <>
                          <a
                            href={checkLearnMoreReplaceUrl(product?.url)}
                            className="sd-text-sm  hover:sd-no-underline sd-underline sd-py-1 sd-whitespace-nowrap sd-mb-0 sd-relative"
                          >
                            <span>{t("learnMore")}</span>
                          </a>
                        </>
                        :
                        <></>}
                      </div>
                    </div>
                  </SplideSlide>
                ))}
          </Splide>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SearchProducts;